<ngx-loading
[show]="loading"
[config]="{  backdropBorderRadius: '3px',  primaryColour: '#630f12', secondaryColour: '#630f12', tertiaryColour: '#ffcb05' }"
></ngx-loading>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
    [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="(isHandset$ | async) === false">
    <app-left-navbar></app-left-navbar>
  </mat-sidenav>
  <mat-sidenav-content style="background-color: bisque;">
    <mat-toolbar class="pageHeader">
      <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>Assign Reviewer</span>
    </mat-toolbar>
    <!-- Add Content Here -->
    <div class="content-body">
      <div class="main-panel">
        <div class="content-wrapper">
          <!-- Page Title Header Starts-->
          <div class="row">
            <mat-divider></mat-divider>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-toolbar class="page-toolbar">
                <button mat-button class="example-icon" routerLink="/add-reviewer">
                  <mat-icon matListIcon>group_add</mat-icon>
                  <a matLine>Add Reviewer</a>
                </button>
                <!--<span class="example-spacer"></span>
                <button mat-icon-button class="example-icon favorite-icon"
                  aria-label="Example icon-button with heart icon">
                  <mat-icon>favorite</mat-icon>
                </button>
                <button mat-icon-button class="example-icon" aria-label="Example icon-button with share icon">
                  <mat-icon>share</mat-icon>
                </button> -->
              </mat-toolbar>
            </div>
            <div class="col-lg-12 col-md-12 col-sm-12">
              <mat-card>
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                      <!--- Note that these columns can be defined in any order.
                                      The actual rendered columns are set as a property on the row definition" -->

                      <!-- Applicant ID Column -->
                      <ng-container matColumnDef="ID">
                        <th mat-header-cell *matHeaderCellDef> ID. </th>
                        <td class="app-id" mat-cell *matCellDef="let element"><a>{{element.personId}}</a></td>
                      </ng-container>

                      <!-- Applicant Name -->
                      <ng-container matColumnDef="Email">
                        <th mat-header-cell *matHeaderCellDef> Email </th>
                        <td mat-cell *matCellDef="let element"> {{element.applicantName}} </td>
                      </ng-container>

                      <!-- Programme Choice -->
                      <ng-container matColumnDef="Name">
                        <th mat-header-cell *matHeaderCellDef> Name of Reviewer </th>
                        <td mat-cell *matCellDef="let element"> {{element.programmeType}} </td>
                      </ng-container>

                      <!-- Programme Type -->
                      <ng-container matColumnDef="Degree">
                        <th mat-header-cell *matHeaderCellDef> Degree </th>
                        <td mat-cell *matCellDef="let element"> {{element.Type}} </td>
                      </ng-container>

                      <!-- Country -->
                      <ng-container matColumnDef="Diploma">
                        <th mat-header-cell *matHeaderCellDef> Diploma </th>
                        <td mat-cell *matCellDef="let element"> {{element.country}} </td>
                      </ng-container>

                      <!-- City -->
                      <ng-container matColumnDef="Certificate">
                        <th mat-header-cell *matHeaderCellDef> Certificate </th>
                        <td mat-cell *matCellDef="let element"> {{element.city}} </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                  </div>
                </div>
              </mat-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>